import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { MonthGeneration } from 'entities/MonthGeneration';

const token: string = localStorage.getItem('token')
  ? JSON.parse(localStorage.getItem('token') || '')
  : '';

export const monthGenerationApi = createApi({
  reducerPath: 'monthGenerationApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_API_URL}` }),
  tagTypes: ['MonthGeneration'],
  endpoints: (builder) => ({
    updateMonthGenerationList: builder.mutation<
      void,
      { consumerUnitId: string; monthGenerationList: MonthGeneration[] }
    >({
      query: ({ consumerUnitId, monthGenerationList }) => ({
        url: `/month-generations/${consumerUnitId}`,
        method: 'PATCH',
        mode: 'cors',
        body: {
          monthGenerationList,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
});

export const { useUpdateMonthGenerationListMutation } = monthGenerationApi;
